import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
// ✅ Import Helmet
import axios from "axios";
import OfferBanner from "../homepage/OfferBanner";
import Category from "../homepage/Category";
import CustomSwiper from "../homepage/CustomSwiper";
import HomeVegetables from "../elementsui/HomeVegetables";
import HomeVegetableSlider from "../homepage/HomeVegetableSlider";
import SalesOfTheDay from "../homepage/SalesOfTheDay";
import HomeSpecialVeg from "../homepage/HomeSpecialVeg";
import HeadingSection from "../elementsui/HeadingSection";
import BottomCartNav from "../Header/BottomCartNav";
import Preloader from "../common/preloader";

const HomePage = () => {
  const [specialOffers, setSpecialOffers] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const category = "home";
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchSpecialOffers = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/api/products/category/${category}`);
        const offers = response.data.map((product) => ({
          _id: product._id,
          url: product.image || (product.images && product.images[0]) || "",
          productId: product._id,
          name: product.name,
        }));
        setSpecialOffers(offers);
        setError(null);
      } catch (err) {
        console.error("Error fetching special offers:", err);
        setError("Could not load special offers");
      } finally {
        setLoading(false);
      }
    };

    fetchSpecialOffers();
  }, [category, API_BASE_URL]);

  if (loading) {
    return <Preloader />;
  }

  if (error) {
    return <div className="text-danger text-center">{error}</div>;
  }

  return (
    <div>
      {/* ✅ SEO Helmet Tags */}
      <Helmet>
        <title>binzal | Fresh Grocery, Vegetables & Essentials Delivery in Bihar</title>
        <meta
          name="description"
          content="Get fresh vegetables, groceries, and daily essentials delivered fast across Bihar with binzal. Serving Patna, Gaya, Muzaffarpur & more."
        />
        <meta
          name="keywords"
          content="binzal, grocery delivery Bihar, vegetables online Patna, quick commerce Bihar, buy groceries online"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="binzal | Bihar's Fastest Grocery Delivery App" />
        <meta
          property="og:description"
          content="Order vegetables, groceries, and stationery online with binzal. Fast delivery in Patna, Gaya, Bhagalpur & all major Bihar cities."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <Category />
      <CustomSwiper />
      <SalesOfTheDay />
      <HomeSpecialVeg />
      <HeadingSection headingText="Fresh From Farm For You!" />
      <OfferBanner images={specialOffers} />
      <HomeVegetableSlider />
      <HeadingSection headingText="Handpicked for you" />
      <HomeVegetables />
      <BottomCartNav />

      <div className="w-100 py-3 px-4 d-flex justify-content-start align-items-center d-md-none">
        <div className="text-start">
          <h2 className="fw-bold lh-sm mb-2" style={{ fontSize: "2rem", color: "#9ce7ac" }}>
            Fast. Fresh. binzal <br />
            For You
          </h2>
          <p className="text-muted m-0 fs-6">
            Crafted with ❤️ in <span className="fw-semibold text-success">Bangalore</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;   